import { render, staticRenderFns } from "./RadioGroupModal.vue?vue&type=template&id=30523bb4&scoped=true"
import script from "./RadioGroupModal.vue?vue&type=script&lang=ts"
export * from "./RadioGroupModal.vue?vue&type=script&lang=ts"
import style0 from "./RadioGroupModal.vue?vue&type=style&index=0&id=30523bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30523bb4",
  null
  
)

export default component.exports